
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import StorageDiagnosticTool from '@/components/admin/StorageDiagnosticTool';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const StorageDiagnostics: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-1 container max-w-7xl mx-auto px-4 py-8 mt-20">
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">
                  <ArrowLeft className="h-4 w-4 mr-1 inline" />
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/settings">Settings</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink>Storage Diagnostics</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Storage System Diagnostics</h1>
          <p className="text-muted-foreground">
            Test and diagnose issues with the Supabase storage system for file uploads.
          </p>
        </div>
        
        <StorageDiagnosticTool />
        
        <div className="mt-8 p-4 bg-muted rounded-lg text-sm text-muted-foreground">
          <p className="mb-1 font-medium">Notes:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>This tool is intended for debugging purposes only</li>
            <li>You must be logged in to run most diagnostics</li>
            <li>Some tests may fail if you don't have the appropriate permissions</li>
            <li>If multiple tests fail, focus on fixing the first error before proceeding</li>
          </ul>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default StorageDiagnostics;
